import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OpeningWarehouseProduct } from "../../interfaces/OpeningWarehouseProduct";
import {
  StorageModel,
  loadArrayFromLocalStorage,
  localStorageKeys,
} from "../../utils/localStorage";

export interface Products {
  searchRows: OpeningWarehouseProduct[];
}

const initialState: Products = {
  searchRows: [],
};

export interface InputQuantity {
  id: number;
  quantity: number;
}

export const openingWarehouseSlice = createSlice({
  name: "openingWarehouseProduct",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<OpeningWarehouseProduct[]>) => {
      const localStorageData: StorageModel[] = loadArrayFromLocalStorage(
        localStorageKeys.likeProduct
      );

      action.payload.forEach((item1, i) => {
        const existedData = localStorageData.find(
          (item2) => item1.id === item2.id
        );
        if (existedData) {
          state.searchRows[i] = { ...item1, isLike: existedData.isLike };
        } else {
          state.searchRows[i] = action.payload[i];
        }
      });
    },
    setLike: (state, action: PayloadAction<number>) => {
      const target = state.searchRows.find(
        (item) => item.id === action.payload
      );
      if (target) {
        target.isLike = !target.isLike;
      }
    },
  },
});

export const { set, setLike } = openingWarehouseSlice.actions;
export default openingWarehouseSlice.reducer;
